(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.InserterHandler = (function(superClass) {
    extend(InserterHandler, superClass);

    function InserterHandler() {
      return InserterHandler.__super__.constructor.apply(this, arguments);
    }

    InserterHandler.prototype.init = function() {
      this.layoutUrl = 'backend/admin/inserter/load-layout-sidebar';
      this.layoutSelector = App.sidebar.contentDiv();
      this.singleSubHandler = true;
      this.subHandlers = {
        'InserterDialog': {
          'class': 'admin::handlers/inserter/InserterDialogHandler'
        }
      };
      this.type = null;
      return this.loadLayout();
    };

    InserterHandler.prototype.afterLoadLayout = function(selector, data) {
      var ths;
      ths = this;
      $(selector).find('#div_ajax_loading').hide();
      $(selector).find('.type-btn').bind('click', function() {
        ths.type = $(this).data('type');
        $(selector).find('.inserter-options').hide();
        return $(selector).find('.' + ths.type + '-inserter-options').show();
      });
      return $(selector).find('#btn_start_upload').bind('click', function() {
        var extradata, hdn_forreal, i, j, len, typedata;
        if ($(this).hasClass('disabled') || !$(selector).find('#upload_form input[name="excel_file"]').val() || (ths.type == null)) {
          return;
        }
        ths.destroyAllSubHandlers();
        hdn_forreal = $(selector).find('#upload_form input[name="hdn_forreal"]');
        extradata = $(selector).find('.' + ths.type + '-inserter-options form').serializeArray();
        typedata = {};
        for (j = 0, len = extradata.length; j < len; j++) {
          i = extradata[j];
          typedata[i.name] = i.value;
        }
        typedata = ko.toJSON(typedata);
        data = new FormData();
        data.append('file', $(selector).find('#upload_form input[name="excel_file"]')[0].files[0]);
        data.append('forreal', hdn_forreal.val());
        data.append('type', ths.type);
        data.append('type_data', typedata);
        $(selector).find('#div_ajax_loading').show();
        $(this).addClass('disabled');
        if (hdn_forreal.val()) {
          $(selector).find('#foshizzle').show();
        } else {
          $(selector).find('#foshizzle').hide();
        }
        hdn_forreal.val('');
        return $.ajax({
          url: 'backend/admin/inserter/handle-upload',
          type: 'POST',
          xhr: function() {
            var myXhr;
            myXhr = $.ajaxSettings.xhr();
            if (myXhr.upload) {
              myXhr.upload.addEventListener('progress', function(e) {
                if (e.lengthComputable) {
                  return $('progress').attr({
                    value: e.loaded,
                    max: e.total
                  });
                }
              }, false);
            }
            return myXhr;
          },
          data: data,
          cache: false,
          contentType: false,
          processData: false
        }).done(function(data) {
          var e, handler, json, ref, writer;
          $(selector).find('#div_ajax_loading').hide();
          $(selector).find('#btn_start_upload').removeClass('disabled');
          json = null;
          try {
            json = JSON.parse(data);
          } catch (error) {
            e = error;
            json = data;
          }
          if (json != null) {
            if (((ref = json.status) != null ? ref.type : void 0) === 'error') {
              writer = App.sidebar.messageWriter();
              writer.message_writer('error', json.status.msg, 2);
              return $('progress').removeAttr('value max');
            } else {
              handler = ths.createSubHandler('InserterDialog');
              if (handler) {
                handler.data = json;
                handler.type = ths.type;
                handler.loadLayoutPostOptions = {
                  'type': ths.type,
                  'forreal': json.doCommit && (json.exception == null)
                };
                return handler.init();
              }
            }
          }
        });
      });
    };

    return InserterHandler;

  })(Handler);

}).call(this);
